import { queryStrings } from "@/constants/query-strings";
import { storeMutations } from "@/constants/store-mutations";
import { debugLog } from "@/helpers/debug-log-helper";
import { routeData } from "@/router/constants/routes";
import { isVerifiedInsurance } from "@/router/methods/helpers/requires-verified-redirect";
import store from "@/store";

export async function quoteBeforeEnter(to, from) {
    debugLog("quoteBeforeEnter", store.getters.order?.isNewInsuranceFlow);
    if (isVerifiedInsurance() && !store.getters.order?.isNewInsuranceFlow) {
        return {
            name: routeData.HERITAGE.name,
            replace: true,
        };
    }

    if (isVerifiedInsurance() && store.getters.order?.isNewInsuranceFlow) {
        return {
            name: routeData.POLICY_INFO.name,
            replace: true,
        };
    }

    const offerQuote = to.query?.[queryStrings.OFFER_QUOTE];

    if (offerQuote === "true") {
        store.commit(storeMutations.UPDATE_IS_INSURANCE, false);
    }
}
